import React, { useContext, useRef, useEffect } from "react";

import { Container, Row, Col } from "reactstrap";
import { Link, NavLink } from "react-router-dom";
import "../../styles/header.css";
import { globalContext } from "../Layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { toggleRegister, toggleLogin } from "../../Features/authSlice";

const navLinks = [
  {
    path: "/home",
    display: "Home",
  },
  {
    path: "/about",
    display: "About",
  },
  // {
  //   path: "/cars",
  //   display: "Cars",
  // },

  // {
  //   path: "/blogs",
  //   display: "Blog",
  // },
  {
    path: "/contact",
    display: "Contact",
  },
  {
    path: "/profile",
    display: "Profile",
  },
];

const Header = () => {
  // const { toggleLogin } = useContext(globalContext);
  // const { toggleRegister } = useContext(globalContext);

  const dispatch = useDispatch();
  const {currentUser} = useSelector(state=>state.user)
  const loginModal = useSelector((state) => state.auth.loginModal);
  const signUpModal = useSelector((state) => state.auth.signUpModal);
  

  useEffect(() => {}, [navLinks]);

  const menuRef = useRef(null);

  const toggleMenu = () => menuRef.current.classList.toggle("menu__active");

  return (
    <header className="header">
      {/* ============ header top ============ */}
      <div className="header__top">
        <Container>
          <Row>
            <Col lg="6" md="6" sm="6">
              <div
                className="header__top__left navigation menu"
                ref={menuRef}
                onClick={toggleMenu}
              >
                {/* <span>Need Help?</span>
                <span className="header__top__help">
                  <i class="ri-phone-fill"></i> +1-202-555-0149
                </span> */}
                {/* <span className="mobile__menu">
                  <i class="ri-menu-line" onClick={toggleMenu}></i>
                </span> */}
                {/* 
                <div
                  className="navigation menu"
                  ref={menuRef}
                  onClick={toggleMenu}
                > */}
                {navLinks.map((item, index) => {
                  if (item.display !== "Profile") {
                    return (
                      <NavLink
                        to={item.path}
                        className={(navClass) =>
                          navClass.isActive
                            ? "nav__active nav__item"
                            : "nav__item"
                        }
                        key={index}
                      >
                        {item.display}
                      </NavLink>
                    );
                  }
                })}
              </div>
              {/* </div> */}
            </Col>

            <Col lg="6" md="6" sm="6">
              <div className="header__top__right d-flex align-items-center justify-content-end gap-3">
                <div className="nav__right search__box">
                  <input type="text" placeholder="Search" />
                  <span>
                    <i class="ri-search-line"></i>
                  </span>
                </div>
               
                {/* !sessionStorage.getItem("isValid") */}
                {!sessionStorage.getItem("token") ? (
                  <>
                    <Link
                      to="#"
                      className=" d-flex align-items-center gap-1"
                      onClick={() => dispatch(toggleLogin())}
                    >
                      <i
                        class="ri-login-circle-line"
                        onClick={() => dispatch(toggleLogin())}
                      ></i>{" "}
                      Login
                    </Link>
                    <Link
                      to="#"
                      className=" d-flex align-items-center gap-1"
                      onClick={() => dispatch(toggleRegister())}
                    >
                      <i
                        class="ri-user-line"
                        onClick={() => dispatch(toggleRegister())}
                      ></i>{" "}
                      Register
                    </Link>
                  </>
                ) : (
                  <Link
                    to="/profile"
                    className=" d-flex align-items-center gap-1"
                  >
                    <i class="ri-user-line"></i> Profile
                  </Link>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* =============== header middle =========== */}
      {/* <div className="header__middle">
        <Container>
          <Row>
            <Col lg="4" md="3" sm="4">
              <div className="logo">
                <h1>
                  <Link to="/home" className=" d-flex align-items-center gap-2">
                    <i class="ri-car-line"></i>
                    <span>
                      Rent Car <br /> Service
                    </span>
                  </Link>
                </h1>
              </div>
            </Col>

            <Col lg="3" md="3" sm="4">
              <div className="header__location d-flex align-items-center gap-2">
                <span>
                  <i class="ri-earth-line"></i>
                </span>
                <div className="header__location-content">
                  <h4>Pune</h4>
                  <h6>Hinjewadi phase-2, Pune, India</h6>
                </div>
              </div>
            </Col>

            <Col lg="3" md="3" sm="4">
              <div className="header__location d-flex align-items-center gap-2">
                <span>
                  <i class="ri-time-line"></i>
                </span>
                <div className="header__location-content">
                  <h4>Sunday to Friday</h4>
                  <h6>10am - 7pm</h6>
                </div>
              </div>
            </Col>

            <Col
              lg="2"
              md="3"
              sm="0"
              className=" d-flex align-items-center justify-content-end "
            >
              <button className="header__btn btn ">
                <Link to="/contact">
                  <i class="ri-phone-line"></i> Request a call
                </Link>
              </button>
            </Col>
          </Row>
        </Container>
      </div> */}

      {/* ========== main navigation =========== */}

      {/* <div className="main__navbar">
        <Container>
          <div className="navigation__wrapper d-flex align-items-center justify-content-between">
            <span className="mobile__menu">
              <i class="ri-menu-line" onClick={toggleMenu}></i>
            </span>

            <div className="navigation menu" ref={menuRef} onClick={toggleMenu}>
              {navLinks.map((item, index) => {
                if (item.display !== "Profile") {
                  return (
                    <NavLink
                      to={item.path}
                      className={(navClass) =>
                        navClass.isActive
                          ? "nav__active nav__item"
                          : "nav__item"
                      }
                      key={index}
                    >
                      {item.display}
                    </NavLink>
                  );
                }
              })}
            </div>

            <div className="nav__right search__box">
              <input type="text" placeholder="Search" />
              <span>
                <i class="ri-search-line"></i>
              </span>
            </div>
          </div>
        </Container>
      </div> */}
    </header>
  );
};

export default Header;
